// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MFOy9H77cm_JtZ {
  margin: var(--ds-space-0, 0) auto var(--ds-space-0, 0) auto;
}
.NcWCUTNEcbiPai {
  text-align: center;
}
.dHmCaKmDxkE3jb {
  margin: var(--ds-space-0, 0) var(--ds-space-500, 40px) var(--ds-space-300, 24px) var(--ds-space-500, 40px);
  text-align: center;
}
.rSKpuP8sX3V7un {
  margin-block-end: var(--ds-space-200, 16px);
  padding: var(--ds-space-0, 0);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
}
.ooGEcgmtjdFXlS {
  margin: var(--ds-space-300, 24px) auto var(--ds-space-0, 0) auto;
}
.FYObAwEBzrSQd5 {
  margin: var(--ds-space-0, 0);
}
a.Qbf9nnh7uzwGWS {
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
export var header = `MFOy9H77cm_JtZ`;
export var headerTitle = `NcWCUTNEcbiPai`;
export var subtitle = `dHmCaKmDxkE3jb`;
export var boardListTitle = `rSKpuP8sX3V7un`;
export var boardListContainer = `ooGEcgmtjdFXlS`;
export var boardList = `FYObAwEBzrSQd5`;
export var learnHow = `Qbf9nnh7uzwGWS`;
export default ___CSS_LOADER_EXPORT___;
